

export const frontMatter = {
	sidebar_position: 4,
	license: 'republish',
	author: 'Jan van Steenbergen',
	origin: 'http://steen.free.fr/interslavic/pronunciation.html'
};
export const contentTitle = 'Вымаўленне';
export {default as metadata} from '@site/.docusaurus/docusaurus-plugin-content-docs/default/site-i-18-n-be-docusaurus-plugin-content-docs-current-learn-pronunciation-md-44e.json'
export const assets = {

};

import {Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs} from "react/jsx-runtime";
import {useMDXComponents as _provideComponents} from "@mdx-js/react";
export const toc = [{
  "value": "Агляд",
  "id": "overview",
  "level": 2
}, {
  "value": "Пашырэнні этымалагічнага алфавіту",
  "id": "etymological-alphabet-extensions",
  "level": 2
}, {
  "value": "Стрэс",
  "id": "stress",
  "level": 2
}, {
  "value": "Агульная заўвага",
  "id": "general-remark",
  "level": 2
}];
function _createMdxContent(props) {
  const _components = {
    a: "a",
    code: "code",
    em: "em",
    h1: "h1",
    h2: "h2",
    header: "header",
    li: "li",
    ol: "ol",
    p: "p",
    span: "span",
    strong: "strong",
    u: "u",
    ul: "ul",
    ..._provideComponents(),
    ...props.components
  }, {CustomAfterSection, CustomBeforeSection, IPA, MDPronunciation1, MDPronunciation2, TransliteratorElement} = _components;
  if (!CustomAfterSection) _missingMdxReference("CustomAfterSection", true);
  if (!CustomBeforeSection) _missingMdxReference("CustomBeforeSection", true);
  if (!IPA) _missingMdxReference("IPA", true);
  if (!MDPronunciation1) _missingMdxReference("MDPronunciation1", true);
  if (!MDPronunciation2) _missingMdxReference("MDPronunciation2", true);
  if (!TransliteratorElement) _missingMdxReference("TransliteratorElement", true);
  return _jsxs(_Fragment, {
    children: [_jsx(_components.header, {
      children: _jsx(_components.h1, {
        id: "вымаўленне",
        children: "Вымаўленне"
      })
    }), "\n", _jsx(_components.h2, {
      id: "overview",
      children: "Агляд"
    }), "\n", _jsx(CustomBeforeSection, {}), "\n", _jsx(_components.p, {
      children: "Як вымаўляюцца этнічныя мовы, вызначаюць іх носьбіты. Гэта датычыцца і міжславянскай мовы: хоць гэта і не этнічная мова, і не мова, прызначаная ў якасці стандартнай для славян, яна павінна быць для славян зручнай і звыклай для вымаўлення. Усе славянскія націскі аднолькава правільныя: гэтак жа, як брытанскае, амерыканскае і аўстралійскае вымаўленне аднолькава правільнае ў англійскай мове, рускае вымаўленне міжславянскага ні ў якім разе не лепшае і не горшае за сербскае ці польскае вымаўленне. У выніку вымаўленне большасці гукаў (фанем) з'яўляецца зменлівым у залежнасці ад нацыянальнасці носьбіта, і любое вымаўленне, прыведзенае ніжэй, з'яўляецца толькі прыблізным. Аднак той факт, што вымаўленне даволі свабоднае, не азначае, што не можа быць «ідэальнага» вымаўлення для кожнай фанемы."
    }), "\n", _jsx(_components.p, {
      children: "Усе літары можна вымаўляць так, як яны вымаўляюцца ў любым славянскім алфавіце. У наступнай табліцы выключэнні прыведзены ў трэцім слупку:"
    }), "\n", _jsx(MDPronunciation1, {
      children: _jsxs(_components.ul, {
        children: ["\n", _jsxs(_components.li, {
          children: ["як ", _jsx(_components.code, {
            children: "a"
          }), " у ", _jsxs(_components.span, {
            className: "notranslate",
            translate: "no",
            lang: "en",
            children: ["f", _jsx(_components.strong, {
              children: "a"
            }), "ther"]
          })]
        }), "\n", _jsxs(_components.li, {
          children: ["як ", _jsx(_components.code, {
            children: "b"
          }), " у ", _jsxs(_components.span, {
            className: "notranslate",
            translate: "no",
            lang: "en",
            children: [_jsx(_components.strong, {
              children: "b"
            }), "ook"]
          })]
        }), "\n", _jsxs(_components.li, {
          children: ["як ", _jsx(_components.code, {
            children: "ts"
          }), " у ", _jsxs(_components.span, {
            className: "notranslate",
            translate: "no",
            lang: "en",
            children: ["bi", _jsx(_components.strong, {
              children: "ts"
            })]
          })]
        }), "\n", _jsxs(_components.li, {
          children: ["як ", _jsx(_components.code, {
            children: "ch"
          }), " у ", _jsxs(_components.span, {
            className: "notranslate",
            translate: "no",
            lang: "en",
            children: [_jsx(_components.strong, {
              children: "ch"
            }), "urch"]
          })]
        }), "\n", _jsxs(_components.li, {
          children: ["як ", _jsx(_components.code, {
            children: "d"
          }), " у ", _jsxs(_components.span, {
            className: "notranslate",
            translate: "no",
            lang: "en",
            children: [_jsx(_components.strong, {
              children: "d"
            }), "eer"]
          })]
        }), "\n", _jsxs(_components.li, {
          children: ["як ", _jsx(_components.code, {
            children: "j"
          }), " у ", _jsxs(_components.span, {
            className: "notranslate",
            translate: "no",
            lang: "en",
            children: [_jsx(_components.strong, {
              children: "J"
            }), "ohn"]
          })]
        }), "\n", _jsxs(_components.li, {
          children: ["як ", _jsx(_components.code, {
            children: "e"
          }), " у ", _jsxs(_components.span, {
            className: "notranslate",
            translate: "no",
            lang: "en",
            children: ["b", _jsx(_components.strong, {
              children: "e"
            }), "st"]
          })]
        }), "\n", _jsxs(_components.li, {
          children: ["як ", _jsx(_components.code, {
            children: "ye"
          }), " у ", _jsxs(_components.span, {
            className: "notranslate",
            translate: "no",
            lang: "en",
            children: [_jsx(_components.strong, {
              children: "ye"
            }), "t"]
          })]
        }), "\n", _jsxs(_components.li, {
          children: ["як ", _jsx(_components.code, {
            children: "f"
          }), " у ", _jsxs(_components.span, {
            className: "notranslate",
            translate: "no",
            lang: "en",
            children: [_jsx(_components.strong, {
              children: "f"
            }), "orest"]
          })]
        }), "\n", _jsxs(_components.li, {
          children: ["як ", _jsx(_components.code, {
            children: "g"
          }), " у ", _jsxs(_components.span, {
            className: "notranslate",
            translate: "no",
            lang: "en",
            children: [_jsx(_components.strong, {
              children: "g"
            }), "ood"]
          })]
        }), "\n", _jsxs(_components.li, {
          children: ["як ", _jsx(_components.code, {
            children: "ch"
          }), " на шатландскай ", _jsxs(_components.span, {
            className: "notranslate",
            translate: "no",
            lang: "en",
            children: ["lo", _jsx(_components.strong, {
              children: "ch"
            })]
          })]
        }), "\n", _jsxs(_components.li, {
          children: ["як ", _jsx(_components.code, {
            children: "ea"
          }), " у ", _jsxs(_components.span, {
            className: "notranslate",
            translate: "no",
            lang: "en",
            children: ["b", _jsx(_components.strong, {
              children: "ea"
            }), "t"]
          })]
        }), "\n", _jsxs(_components.li, {
          children: ["як ", _jsx(_components.code, {
            children: "y"
          }), " у ", _jsxs(_components.span, {
            className: "notranslate",
            translate: "no",
            lang: "en",
            children: [_jsx(_components.strong, {
              children: "y"
            }), "ard"]
          })]
        }), "\n", _jsxs(_components.li, {
          children: ["як ", _jsx(_components.code, {
            children: "k"
          }), " па-англійску, але без аспірацыі"]
        }), "\n", _jsxs(_components.li, {
          children: ["як ", _jsx(_components.code, {
            children: "l"
          }), " на англійскай мове"]
        }), "\n", _jsxs(_components.li, {
          children: ["як ", _jsx(_components.code, {
            children: "li"
          }), " у ", _jsxs(_components.span, {
            className: "notranslate",
            translate: "no",
            lang: "en",
            children: ["mil", _jsx(_components.strong, {
              children: "li"
            }), "on"]
          })]
        }), "\n", _jsxs(_components.li, {
          children: ["як ", _jsx(_components.code, {
            children: "m"
          }), " у ", _jsxs(_components.span, {
            className: "notranslate",
            translate: "no",
            lang: "en",
            children: [_jsx(_components.strong, {
              children: "m"
            }), "op"]
          })]
        }), "\n", _jsxs(_components.li, {
          children: ["як ", _jsx(_components.code, {
            children: "n"
          }), " у ", _jsxs(_components.span, {
            className: "notranslate",
            translate: "no",
            lang: "en",
            children: [_jsx(_components.strong, {
              children: "n"
            }), "orth"]
          })]
        }), "\n", _jsxs(_components.li, {
          children: ["як ", _jsx(_components.code, {
            children: "ny"
          }), " у ", _jsxs(_components.span, {
            className: "notranslate",
            translate: "no",
            lang: "en",
            children: ["ca", _jsx(_components.strong, {
              children: "ny"
            }), "on"]
          })]
        }), "\n", _jsxs(_components.li, {
          children: ["як ", _jsx(_components.code, {
            children: "o"
          }), " у ", _jsxs(_components.span, {
            className: "notranslate",
            translate: "no",
            lang: "en",
            children: [_jsx(_components.strong, {
              children: "o"
            }), "r"]
          })]
        }), "\n", _jsxs(_components.li, {
          children: ["як ", _jsx(_components.code, {
            children: "p"
          }), " па-ангельску, але без прыдыханьня"]
        }), "\n", _jsxs(_components.li, {
          children: ["пакаціў ", _jsx(_components.code, {
            children: "r"
          })]
        }), "\n", _jsxs(_components.li, {
          children: ["як ", _jsx(_components.code, {
            children: "s"
          }), " у ", _jsxs(_components.span, {
            className: "notranslate",
            translate: "no",
            lang: "en",
            children: [_jsx(_components.strong, {
              children: "s"
            }), "pin"]
          })]
        }), "\n", _jsxs(_components.li, {
          children: ["як ", _jsx(_components.code, {
            children: "sh"
          }), " у ", _jsxs(_components.span, {
            className: "notranslate",
            translate: "no",
            lang: "en",
            children: [_jsx(_components.strong, {
              children: "sh"
            }), "op"]
          })]
        }), "\n", _jsxs(_components.li, {
          children: ["як ", _jsx(_components.code, {
            children: "t"
          }), " па-англійску, але без аспірацыі"]
        }), "\n", _jsxs(_components.li, {
          children: ["як ", _jsx(_components.code, {
            children: "oo"
          }), " у ", _jsxs(_components.span, {
            className: "notranslate",
            translate: "no",
            lang: "en",
            children: ["b", _jsx(_components.strong, {
              children: "oo"
            }), "k"]
          })]
        }), "\n", _jsxs(_components.li, {
          children: ["як ", _jsx(_components.code, {
            children: "v"
          }), " у ", _jsxs(_components.span, {
            className: "notranslate",
            translate: "no",
            lang: "en",
            children: ["a", _jsx(_components.strong, {
              children: "v"
            }), "oid"]
          })]
        }), "\n", _jsxs(_components.li, {
          children: ["як ", _jsx(_components.code, {
            children: "i"
          }), " у ", _jsxs(_components.span, {
            className: "notranslate",
            translate: "no",
            lang: "en",
            children: ["b", _jsx(_components.strong, {
              children: "i"
            }), "t"]
          })]
        }), "\n", _jsxs(_components.li, {
          children: ["як ", _jsx(_components.code, {
            children: "z"
          }), " у ", _jsxs(_components.span, {
            className: "notranslate",
            translate: "no",
            lang: "en",
            children: [_jsx(_components.strong, {
              children: "z"
            }), "oo"]
          })]
        }), "\n", _jsxs(_components.li, {
          children: ["як ", _jsx(_components.code, {
            children: "si"
          }), " у ", _jsxs(_components.span, {
            className: "notranslate",
            translate: "no",
            lang: "en",
            children: ["vi", _jsx(_components.strong, {
              children: "si"
            }), "on"]
          })]
        }), "\n"]
      })
    }), "\n", _jsx(_components.p, {
      children: _jsx(_components.strong, {
        children: "Заўвагі:"
      })
    }), "\n", _jsxs(_components.ol, {
      children: ["\n", _jsxs(_components.li, {
        children: ["У вымаўленні галосных, як правіла, ёсць некаторыя варыяцыі ў шкале адкрыты/закрыты і пярэдні/задні. Толькі ", _jsx(TransliteratorElement, {
          children: _jsx(_components.code, {
            children: "u"
          })
        }), " заўсёды ", _jsx(IPA, {
          children: "u"
        }), "."]
      }), "\n", _jsxs(_components.li, {
        children: ["Каб пазбегнуць размытасці, варта пазбягаць акання (вымаўленне ненаціскных галосных як ", _jsx(IPA, {
          children: "ɑ"
        }), " або ", _jsx(IPA, {
          children: "ə"
        }), " у рускай мове)."]
      }), "\n", _jsxs(_components.li, {
        children: ["Акрамя ", _jsx(TransliteratorElement, {
          children: _jsx(_components.code, {
            children: "a"
          })
        }), " ", _jsx(TransliteratorElement, {
          children: _jsx(_components.code, {
            children: "e"
          })
        }), " ", _jsx(TransliteratorElement, {
          children: _jsx(_components.code, {
            children: "ě"
          })
        }), " ", _jsx(TransliteratorElement, {
          children: _jsx(_components.code, {
            children: "i"
          })
        }), " ", _jsx(TransliteratorElement, {
          children: _jsx(_components.code, {
            children: "o"
          })
        }), " ", _jsx(TransliteratorElement, {
          children: _jsx(_components.code, {
            children: "u"
          })
        }), " ", _jsx(TransliteratorElement, {
          children: _jsx(_components.code, {
            children: "y"
          })
        }), ",  літара ", _jsx(TransliteratorElement, {
          children: _jsx(_components.code, {
            children: "r"
          })
        }), " таксама можа быць галоснай. Гэта той выпадак, калі ён з'яўляецца пасля зычнага і не суправаджаецца галосным, што прыводзіць да так званага ", _jsx(_components.em, {
          children: "складовага r"
        }), ". Яго трэба вымаўляць са шва перад ім (больш-менш падобна на імя «Мэрфі»): ", _jsx(TransliteratorElement, {
          children: "trg"
        }), " ", _jsx(IPA, {
          children: "tərg"
        }), ", ", _jsx(TransliteratorElement, {
          children: "cukr"
        }), " ", _jsx(IPA, {
          children: "ʦukər"
        }), "."]
      }), "\n", _jsxs(_components.li, {
        children: ["Для палягчэння вымаўлення заўсёды можна ўставіць шву ў нязручную групу зычных: ", _jsx(TransliteratorElement, {
          children: "jesm"
        }), " ", _jsx(IPA, {
          children: "jɛsǝm"
        }), ", ", _jsx(TransliteratorElement, {
          children: "himn"
        }), " ", _jsx(IPA, {
          children: "ximǝn"
        }), ", ", _jsx(TransliteratorElement, {
          children: "vedl"
        }), " ", _jsx(IPA, {
          children: "vɛdǝl"
        }), "."]
      }), "\n", _jsx(_components.li, {
        children: "Асобы, якія размаўляюць на такіх мовах, як ангельская і нямецкая, павінны ведаць, што трэба пазбягаць любога тыпу памкненняў (напрыклад, у англійскай «свініна» або нямецкай «Tüte»)."
      }), "\n", _jsxs(_components.li, {
        children: ["Калі ", _jsx(TransliteratorElement, {
          children: _jsx(_components.code, {
            children: "ě"
          })
        }), " ідзе пасля зубнога/альвеалярнага зычнага (", _jsx(TransliteratorElement, {
          children: _jsx(_components.code, {
            children: "t"
          })
        }), " ", _jsx(TransliteratorElement, {
          children: _jsx(_components.code, {
            children: "d"
          })
        }), " ", _jsx(TransliteratorElement, {
          children: _jsx(_components.code, {
            children: "s"
          })
        }), " ", _jsx(TransliteratorElement, {
          children: _jsx(_components.code, {
            children: "z"
          })
        }), " ", _jsx(TransliteratorElement, {
          children: _jsx(_components.code, {
            children: "n"
          })
        }), " ", _jsx(TransliteratorElement, {
          children: _jsx(_components.code, {
            children: "l"
          })
        }), " ", _jsx(TransliteratorElement, {
          children: _jsx(_components.code, {
            children: "r"
          })
        }), "), гэты зычны вымаўляецца мякка (гл. ", _jsx(_components.a, {
          href: "/be/learn/phonology#hard-and-soft-consonants",
          children: "фаналогія"
        }), "). Пасля іншых зычных ён выдае той жа гук, што і ", _jsx(TransliteratorElement, {
          children: _jsx(_components.code, {
            children: "e"
          })
        }), ", але перад ім ", _jsx(TransliteratorElement, {
          children: _jsx(_components.code, {
            children: "j"
          })
        }), ": ", _jsx(TransliteratorElement, {
          children: "dělo"
        }), " гучыць як ", _jsx(_components.span, {
          className: "notranslate",
          translate: "no",
          children: "ďelo"
        }), ", ", _jsx(TransliteratorElement, {
          children: "pěsok"
        }), " , як ", _jsx(_components.span, {
          className: "notranslate",
          translate: "no",
          children: "pjesok"
        }), "."]
      }), "\n", _jsxs(_components.li, {
        children: ["Зычны перад ", _jsx(TransliteratorElement, {
          children: _jsx(_components.code, {
            children: "i"
          })
        }), " таксама можна вымаўляць мякка, але гэта неабавязкова."]
      }), "\n", _jsxs(_components.li, {
        children: ["Сапраўды гэтак жа, зычны па сваёй сутнасці мяккі перад ", _jsx(TransliteratorElement, {
          children: _jsx(_components.code, {
            children: "j"
          })
        }), ", калі толькі гэты зычны не з'яўляецца часткай прэфікса: ", _jsx(TransliteratorElement, {
          children: "žitje"
        }), " вымаўляецца як ", _jsx(_components.span, {
          className: "notranslate",
          translate: "no",
          children: "žiťje"
        }), ", але ў слове ", _jsx(TransliteratorElement, {
          children: "odjehati"
        }), " ", _jsx(TransliteratorElement, {
          children: _jsx(_components.code, {
            children: "d"
          })
        }), " застаецца цвёрдым."]
      }), "\n", _jsxs(_components.li, {
        children: ["З іншага боку, хаця праславянская фанема ", _jsx(TransliteratorElement, {
          children: _jsx(_components.code, {
            children: "e"
          })
        }), " змякчае папярэдні зычны ў польскай і рускай мовах, у гэтым выпадку лепш захоўваць цвёрдае вымаўленне."]
      }), "\n", _jsxs(_components.li, {
        children: ["Літара ", _jsx(TransliteratorElement, {
          children: _jsx(_components.code, {
            children: "l"
          })
        }), " - асаблівы выпадак. Перад ", _jsx(TransliteratorElement, {
          children: _jsx(_components.code, {
            children: "a"
          })
        }), " ", _jsx(TransliteratorElement, {
          children: _jsx(_components.code, {
            children: "o"
          })
        }), " ", _jsx(TransliteratorElement, {
          children: _jsx(_components.code, {
            children: "u"
          })
        }), " ", _jsx(TransliteratorElement, {
          children: _jsx(_components.code, {
            children: "y"
          })
        }), ", , а таксама syllable-finally, гучыць як «тоўсты» ", _jsx(TransliteratorElement, {
          children: _jsx(_components.code, {
            children: "l"
          })
        }), " у ", _jsx(_components.span, {
          className: "notranslate",
          translate: "no",
          lang: "en",
          children: "full"
        }), ". Перад ", _jsx(TransliteratorElement, {
          children: _jsx(_components.code, {
            children: "e"
          })
        }), ", ", _jsx(TransliteratorElement, {
          children: _jsx(_components.code, {
            children: "ě"
          })
        }), "  і ", _jsx(TransliteratorElement, {
          children: _jsx(_components.code, {
            children: "i"
          })
        }), " хутчэй прытрымліваюцца мадэлі вымаўлення ", _jsx(TransliteratorElement, {
          children: _jsx(_components.code, {
            children: "lj"
          })
        }), ": ", _jsx(TransliteratorElement, {
          children: "lev"
        }), " ", _jsx(IPA, {
          children: "lʲɛv"
        }), "  ~ ", _jsx(IPA, {
          children: "ʎɛf"
        }), " і г.д."]
      }), "\n", _jsxs(_components.li, {
        children: ["Не існуе строгіх правілаў выдзялення звонкіх зычных у канцы слова, перад звонкімі перад звонкімі. Любы можа выкарыстоўваць тое вымаўленне, якое яму найбольш зручна. Такім чынам, ", _jsx(TransliteratorElement, {
          children: "Bog"
        }), " ", _jsx(IPA, {
          children: "bɔk"
        }), "  і ", _jsx(TransliteratorElement, {
          children: "prosba"
        }), " ", _jsx(IPA, {
          children: "prɔzbɑ"
        }), "  правільныя. У цэлым, аднак, заслугоўвае рэкамендацыі прытрымлівацца вымаўлення, якое максімальна набліжана да таго, як яно напісана."]
      }), "\n"]
    }), "\n", _jsx(_components.h2, {
      id: "etymological-alphabet-extensions",
      children: "Пашырэнні этымалагічнага алфавіту"
    }), "\n", _jsxs(_components.p, {
      children: ["Акрамя прыведзенага вышэй стандартнага альфабэту, міжславянская лацініца таксама мае набор дадатковых сымбаляў, якія ў асноўным выконваюць дзьве рэчы. Па-першае, яны прадстаўляюць фанемы, якія ў славянскіх мовах развіліся ў розных накірунках, а па-другое, непасрэдна звязваюць іх з праславянскімі вытокамі. Напрыклад, галосная ", _jsx(TransliteratorElement, {
        children: _jsx(_components.code, {
          children: "å"
        })
      }), " у ", _jsx(TransliteratorElement, {
        children: "kråva"
      }), " «карова» паказвае, што гэтае слова паходзіць ад праславянскага ", _jsx(_components.span, {
        className: "notranslate",
        translate: "no",
        lang: "sla",
        children: "korva"
      }), ", якое перайшло ў ", _jsx(_components.span, {
        className: "notranslate",
        translate: "no",
        lang: "pl",
        children: "krova"
      }), " у польскай і лужыцкай мовах, ", _jsx(_components.span, {
        className: "notranslate",
        translate: "no",
        lang: "zle",
        children: "korova"
      }), " ва ўсходнеславянскай і ", _jsx(_components.span, {
        className: "notranslate",
        translate: "no",
        children: "krava"
      }), " ва чэшская, славацкая і паўднёваславянская. Самы крайні выпадак, несумненна, ", _jsx(TransliteratorElement, {
        children: _jsx(_components.code, {
          children: "đ"
        })
      }), " (ад праславянскай ", _jsx(TransliteratorElement, {
        children: _jsx(_components.code, {
          children: "dj"
        })
      }), "), які ў розных мовах ператварыўся ў ", _jsx(IPA, {
        children: "d͡z"
      }), ", ", _jsx(IPA, {
        children: "z"
      }), ", ", _jsx(IPA, {
        children: "ʒ"
      }), ", ", _jsx(IPA, {
        children: "ʒd"
      }), ", ", _jsx(IPA, {
        children: "j"
      }), ",  і г.д."]
    }), "\n", _jsxs(_components.p, {
      children: ["Гэтыя іерогліфы належаць да ", _jsx(_components.a, {
        href: "/be/learn/orthography#etymological-alphabet",
        children: "этымалягічнага альфабэту"
      }), ". Яны не выкарыстоўваюцца ў звычайнай пісьмовай міжславянскай мове, гэта значыць яны пішуцца, але без дыякрытыкі (за выключэннем ", _jsx(TransliteratorElement, {
        children: _jsx(_components.code, {
          children: "ć"
        })
      }), " і ", _jsx(TransliteratorElement, {
        children: _jsx(_components.code, {
          children: "đ"
        })
      }), ", якія пішуцца адпаведна ", _jsx(TransliteratorElement, {
        children: _jsx(_components.code, {
          children: "č"
        })
      }), " і ", _jsx(TransliteratorElement, {
        children: _jsx(_components.code, {
          children: "dž"
        })
      }), "), і, вядома, таксама могуць вымаўляцца як такі. Тым не менш, таксама можна паспрабаваць «сярэдняе» вымаўленне, якое больш адпавядае славянскай большасці. У выпадку вышэйзгаданага ", _jsx(TransliteratorElement, {
        children: "kråva"
      }), ", напрыклад, гэта будзе азначаць гук дзесьці паміж ", _jsx(TransliteratorElement, {
        children: _jsx(_components.code, {
          children: "a"
        })
      }), " і ", _jsx(TransliteratorElement, {
        children: _jsx(_components.code, {
          children: "o"
        })
      }), " (у IPA: ", _jsx(IPA, {
        children: "ɒ"
      }), ")."]
    }), "\n", _jsx(MDPronunciation2, {
      children: _jsxs(_components.ul, {
        children: ["\n", _jsxs(_components.li, {
          children: ["як ", _jsx(_components.code, {
            children: "o"
          }), " у ", _jsxs(_components.span, {
            className: "notranslate",
            translate: "no",
            lang: "en",
            children: ["m", _jsx(_components.strong, {
              children: "o"
            }), "ther"]
          })]
        }), "\n", _jsxs(_components.li, {
          children: ["як ", _jsx(_components.code, {
            children: "ch"
          }), " у ", _jsxs(_components.span, {
            className: "notranslate",
            translate: "no",
            lang: "en",
            children: [_jsx(_components.strong, {
              children: "ch"
            }), "eap"]
          })]
        }), "\n", _jsxs(_components.li, {
          children: ["як ", _jsx(_components.code, {
            children: "d"
          }), " у ", _jsxs(_components.span, {
            className: "notranslate",
            translate: "no",
            lang: "en",
            children: [_jsx(_components.strong, {
              children: "d"
            }), "uke"]
          })]
        }), "\n", _jsxs(_components.li, {
          children: ["як ", _jsx(_components.code, {
            children: "j"
          }), " у ", _jsxs(_components.span, {
            className: "notranslate",
            translate: "no",
            lang: "en",
            children: [_jsx(_components.strong, {
              children: "j"
            }), "eep"]
          })]
        }), "\n", _jsxs(_components.li, {
          children: ["як ", _jsx(_components.code, {
            children: "e"
          }), " у ", _jsxs(_components.span, {
            className: "notranslate",
            translate: "no",
            lang: "en",
            children: ["bett", _jsx(_components.strong, {
              children: "e"
            }), "r"]
          })]
        }), "\n", _jsxs(_components.li, {
          children: ["як ", _jsx(_components.code, {
            children: "ya"
          }), " у ", _jsxs(_components.span, {
            className: "notranslate",
            translate: "no",
            lang: "en",
            children: [_jsx(_components.strong, {
              children: "ya"
            }), "m"]
          })]
        }), "\n", _jsxs(_components.li, {
          children: ["як ", _jsx(_components.code, {
            children: "lj"
          }), ", звычайна перад ", _jsx(_components.code, {
            children: "j"
          }), ", ", _jsx(_components.code, {
            children: "n"
          }), "  або ", _jsx(_components.code, {
            children: "s"
          })]
        }), "\n", _jsxs(_components.li, {
          children: ["як ", _jsx(_components.code, {
            children: "nj"
          }), ", звычайна перад ", _jsx(_components.code, {
            children: "j"
          }), " або ", _jsx(_components.code, {
            children: "s"
          })]
        }), "\n", _jsxs(_components.li, {
          children: ["як ", _jsx(_components.code, {
            children: "o"
          }), " у ", _jsxs(_components.span, {
            className: "notranslate",
            translate: "no",
            lang: "en",
            children: ["mem", _jsx(_components.strong, {
              children: "o"
            }), "ry"]
          })]
        }), "\n", _jsx(_components.li, {
          children: "прыпаднятая альвеалярная трэль"
        }), "\n", _jsxs(_components.li, {
          children: ["як ", _jsx(_components.code, {
            children: "sh"
          }), " у ", _jsxs(_components.span, {
            className: "notranslate",
            translate: "no",
            lang: "en",
            children: [_jsx(_components.strong, {
              children: "sh"
            }), "eet"]
          })]
        }), "\n", _jsxs(_components.li, {
          children: ["як ", _jsx(_components.code, {
            children: "t"
          }), " у ", _jsxs(_components.span, {
            className: "notranslate",
            translate: "no",
            lang: "en",
            children: [_jsx(_components.strong, {
              children: "t"
            }), "ube"]
          })]
        }), "\n", _jsxs(_components.li, {
          children: ["паміж ", _jsx(_components.code, {
            children: "ow"
          }), " у амерыканскім ", _jsxs(_components.span, {
            className: "notranslate",
            translate: "no",
            lang: "en",
            children: ["m", _jsx(_components.strong, {
              children: "ow"
            })]
          }), " і ", _jsx(_components.code, {
            children: "ew"
          }), " у ", _jsxs(_components.span, {
            className: "notranslate",
            translate: "no",
            lang: "en",
            children: ["h", _jsx(_components.strong, {
              children: "ew"
            })]
          })]
        }), "\n", _jsxs(_components.li, {
          children: ["агучаны эквівалент ", _jsx(_components.code, {
            children: "ś"
          })]
        }), "\n"]
      })
    }), "\n", _jsx(_components.p, {
      children: _jsx(_components.strong, {
        children: "Заўвагі:"
      })
    }), "\n", _jsxs(_components.ol, {
      children: ["\n", _jsxs(_components.li, {
        children: ["Асаблівую цікавасць тут уяўляе сімвал ", _jsx(TransliteratorElement, {
          children: _jsx(_components.code, {
            children: "ę"
          })
        }), ". «Цвёрдае» вымаўленне ", _jsx(IPA, {
          children: "ɛ"
        }), " характэрна для паўднёваславянскай мовы, але ў астатніх мовах яго вымаўленне вагаецца паміж ", _jsx(IPA, {
          children: "ja"
        }), ", ", _jsx(IPA, {
          children: "jɛ"
        }), "  і ", _jsx(IPA, {
          children: "jɔ̃"
        }), ". Згодна з правілам большасці, ", _jsx(TransliteratorElement, {
          children: _jsx(_components.code, {
            children: "e"
          })
        }), " павінна вымаўляцца як цвёрдае ", _jsx(IPA, {
          children: "ɛ"
        }), ", але ", _jsx(TransliteratorElement, {
          children: _jsx(_components.code, {
            children: "ę"
          })
        }), " больш падобна на ", _jsx(IPA, {
          children: "jæ"
        }), ". Гэта азначае, што ", _jsx(TransliteratorElement, {
          children: _jsx(_components.code, {
            children: "ę"
          })
        }), " паводзіць сябе як ", _jsx(TransliteratorElement, {
          children: _jsx(_components.code, {
            children: "ě"
          })
        }), ", а не ", _jsx(TransliteratorElement, {
          children: _jsx(_components.code, {
            children: "e"
          })
        }), ", і, як ", _jsx(TransliteratorElement, {
          children: _jsx(_components.code, {
            children: "ě"
          })
        }), ", ён можа змякчыць папярэдні зычны."]
      }), "\n", _jsxs(_components.li, {
        children: ["Нягледзячы на ogonek, ", _jsx(TransliteratorElement, {
          children: _jsx(_components.code, {
            children: "ę"
          })
        }), " і ", _jsx(TransliteratorElement, {
          children: _jsx(_components.code, {
            children: "ų"
          })
        }), " не вымаўляюцца як насавыя галосныя, як у польскай мове!"]
      }), "\n", _jsxs(_components.li, {
        children: ["Мяккія зычныя ", _jsx(TransliteratorElement, {
          children: _jsx(_components.code, {
            children: "t́"
          })
        }), " ", _jsx(TransliteratorElement, {
          children: _jsx(_components.code, {
            children: "d́"
          })
        }), " ", _jsx(TransliteratorElement, {
          children: _jsx(_components.code, {
            children: "ś"
          })
        }), " ", _jsx(TransliteratorElement, {
          children: _jsx(_components.code, {
            children: "ź"
          })
        }), " ", _jsx(TransliteratorElement, {
          children: _jsx(_components.code, {
            children: "ŕ"
          })
        }), "  (вымаўляюцца цвёрда ў паўднёваславянскай, часткова таксама ў чэшскай і славацкай мовах) рэалізуюцца або праз тое, што пасля цвёрдага зычнага ідзе гук, падобны на ", _jsx(TransliteratorElement, {
          children: _jsx(_components.code, {
            children: "j"
          })
        }), ", або праз яго змякчэнне або палаталізацыю."]
      }), "\n", _jsxs(_components.li, {
        children: ["Калі літара ", _jsx(TransliteratorElement, {
          children: _jsx(_components.code, {
            children: "ŕ"
          })
        }), " выступае ў якасці мяккага адпаведніка складовай ", _jsx(TransliteratorElement, {
          children: _jsx(_components.code, {
            children: "r"
          })
        }), ", яна можа змякчаць папярэдні зычны або пасля яго варта ", _jsx(IPA, {
          children: "j"
        }), ": ", _jsx(TransliteratorElement, {
          children: "mŕtvy"
        }), " ", _jsx(IPA, {
          children: "mjǝrtvɪ"
        }), "."]
      }), "\n", _jsxs(_components.li, {
        children: ["Мяккія зычныя ", _jsx(TransliteratorElement, {
          children: _jsx(_components.code, {
            children: "ľ"
          })
        }), " і ", _jsx(TransliteratorElement, {
          children: _jsx(_components.code, {
            children: "ń"
          })
        }), " выкарыстоўваюцца для напісання ", _jsx(TransliteratorElement, {
          children: _jsx(_components.code, {
            children: "lj"
          })
        }), " і ", _jsx(TransliteratorElement, {
          children: _jsx(_components.code, {
            children: "nj"
          })
        }), " перад ", _jsx(TransliteratorElement, {
          children: _jsx(_components.code, {
            children: "j"
          })
        }), ", што прыводзіць да пэўнага падаўжэння апошняга, напрыклад ", _jsx(TransliteratorElement, {
          children: "dělańje"
        }), " ", _jsx(IPA, {
          children: "dʲɛɫanʲĭɛ"
        }), "."]
      }), "\n"]
    }), "\n", _jsx(_components.h2, {
      id: "stress",
      children: "Стрэс"
    }), "\n", _jsx(_components.p, {
      children: "Акцэнтуацыя бясплатная. Аднак, калі вы хочаце быць у бяспецы, варта рэкамендаваць прытрымлівацца наступных інструкцый:"
    }), "\n", _jsxs(_components.ul, {
      children: ["\n", _jsx(_components.li, {
        children: "Калі слова складаецца з двух складоў, націск падае на першы склад."
      }), "\n", _jsx(_components.li, {
        children: "Калі слова трохскладовае, націск падае на першы ці другі склад."
      }), "\n", _jsx(_components.li, {
        children: "Калі слова складаецца з чатырох складоў, націск падае на другі ці трэці склад."
      }), "\n", _jsxs(_components.li, {
        children: ["націск не павінен падвяргацца ўплыву флексіі; калі прыметнік ", _jsx(TransliteratorElement, {
          children: "běly"
        }), " вымаўляецца ", _jsxs(TransliteratorElement, {
          children: ["b", _jsx(_components.u, {
            children: "ě"
          }), "ly"]
        }), ", родны склон павінен вымаўляцца ", _jsxs(TransliteratorElement, {
          children: ["b", _jsx(_components.u, {
            children: "ě"
          }), "logo"]
        }), ", а не ", _jsxs(TransliteratorElement, {
          children: ["běl", _jsx(_components.u, {
            children: "o"
          }), "go"]
        }), "."]
      }), "\n", _jsx(_components.li, {
        children: "Увогуле, лепш пазбягаць націску на прэфіксы, суфіксы, склонавыя канчаткі і г.д."
      }), "\n"]
    }), "\n", _jsx(_components.h2, {
      id: "general-remark",
      children: "Агульная заўвага"
    }), "\n", _jsx(_components.p, {
      children: "Калі справа даходзіць да размовы, заўсёды трэба памятаць, што слухач, напэўна, не знаёмы з міжславянскай, а калі і знаёмы, то не прывык яе чуць. Кожны раз, калі вы выкарыстоўваеце міжславянскую мову ў размове, заўсёды пераканайцеся, што суразмоўца сапраўды вас разумее. Гаварыце павольна, трымайце глядзельны кантакт, выразна артыкулюйце і заўсёды будзьце добрым слухачом. У рэшце рэшт, камунікацыя - гэта не толькі пытанне мовы, не менш важная невербальная частка."
    }), "\n", _jsx(_components.p, {
      children: "Тое ж самае, магчыма, нават больш, калі вы звяртаецеся да аўдыторыі. Міжславянская мова пабудавана для максімальнай зразумеласці, але гэта не азначае, што кожны славянін можа зразумець кожнае яе слова. Слуханне міжславянскай мовы - гэта пастаяннае ўстанаўленне сувязяў і канатацый, і кожны раз, калі чалавек чуе незразумелае слова - што зусім непазбежна - вялікая верагоднасць таго, што ён пачне аб гэтым разважаць і прапусціць рэшту вашага сказа. Неабходна, каб вы заўсёды давалі сваёй аўдыторыі ўвесь час, неабходны для апрацоўкі вашай інфармацыі, каб яна засвоілася. Таму не гаварыце хутка, гаварыце выразна, рабіце глыбокі ўдых паміж сказамі, выкарыстоўвайце прасодыю як мага лепш, і гэтак далей..."
    }), "\n", _jsx(CustomAfterSection, {})]
  });
}
export default function MDXContent(props = {}) {
  const {wrapper: MDXLayout} = {
    ..._provideComponents(),
    ...props.components
  };
  return MDXLayout ? _jsx(MDXLayout, {
    ...props,
    children: _jsx(_createMdxContent, {
      ...props
    })
  }) : _createMdxContent(props);
}
function _missingMdxReference(id, component) {
  throw new Error("Expected " + (component ? "component" : "object") + " `" + id + "` to be defined: you likely forgot to import, pass, or provide it.");
}

